import { useLocalization } from 'redux/localization/utils/hooks';

import ProductLink from '../ProductLink';

import Picture from './common/Picture';

const MainImage = (props) => {
  const { linkType, image, product, size } = props;
  const { t } = useLocalization();

  switch (linkType) {
    case 'None': {
      return <Picture image={image} alt={product.title} size={size} />;
    }
    case 'Ajax':
    case 'Window': {
      return (
        <ProductLink
          linkType={linkType}
          product={product}
          ariaHidden="true"
          tabIndex="-1"
        >
          <Picture image={image} alt={product.title} size={size} />
        </ProductLink>
      );
    }
    default: {
      return t('general.errorMessages.invalidProductLinkType');
    }
  }
};

export default MainImage;
